module.exports = __webpack_public_path__ + "img/verify-img3.771b0b05.jpg";